import React from "react"
import { MainCP } from "../../Components/Ministerio-aprobacion/MainCP"

const ViewMinisterioAP: React.FC = () => <MainCP/>

export default ViewMinisterioAP